<template>
  <div class="left-menu-item">
    <ul >
      <li
        v-for="(item, index) in list"
        :key="index"
        :class="{ 'padding-top_4 padding-bottom_4': true }"
      >
        <div
          :class="{
            'left-menu-item__main padding-left_12 padding-right_12 margin-left_8 margin-right_8 cursor-pointer': true,
            'active-menu': item.IsActive,
            'active-menu_parent': item.IsActiveParent || (item.IsOpen && !item.IsActive && !item.MenuUrl && item.Children.length > 0)
          }"
          @click.stop="toPage(item)"
        >
        
          <i
            :class="['icon iconfont left-icon margin-right_8', item.Icon]"
            v-if="item.ParentID == 0"
          ></i>

          <span
            :class="[
              'center-text',
              'margin-left_' +
                ((item.Level - 1) * 24 + (item.Level > 2 ? -8 : 0)),
            ]"
            >{{ item.MenuName }}</span
          >
          <span
            v-if="item.Children.length > 0"
            :class="{
              'el-icon-arrow-down': true,
              'icon-rotate-0 el-icon-arrow-up': !item.IsOpen,
              'icon-rotate-180 el-icon-arrow-down ': item.IsOpen,
            }"
          ></span><!-- icon iconfont fa-arrDown right-icon-->
        </div>
        <el-collapse-transition>
          <ul
            v-show="item.IsOpen && item.Children.length > 0"
            :class="{ ['active-bg_' + [item.Level + 1]]: item.IsOpen }"
          >
            <li>
              <left-menu-item
                :list="item.Children"
                @activeMenu="handleActiveMenu"
              ></left-menu-item>
            </li>
          </ul>
        </el-collapse-transition>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "LeftMenuItem",
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    toPage(item) {
      this.$emit("activeMenu", item);
    },

    handleActiveMenu(item) {
      this.$emit("activeMenu", item);
    },
  },
};
</script>

<style scoped lang="scss">
.left-menu-item {
  .left-menu-item__main {
    display: flex;
    align-items: center;
    border-radius: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
    }
    .left-icon {
      width: 16px;
      font-size: 16px;
      color: #ffffffb8;
    }

    .center-text {
      flex: 1;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffffb8;
      line-height: 40px;
    }

    .right-icon {
      width: 16px;
      font-size: 16px;
      color: #ffffffb8;
    }
  }

  // .left-menu-item__main-active {
  //   background: #493601;
  //   .center-text {
  //     color: #e7bb3f;
  //   }
  // }

  .active-menu {
    background: #0046b9 !important;
    border-radius: 4px;
    .left-icon,
    .center-text,
    .right-icon {
      color: #fff;
    }
  }

  .active-menu_parent {
    > .left-icon,
    > .center-text,
    > .right-icon {
      color: #fff;
    }
  }

  .active-bg_2 {
    background: #232323;
  }

  .active-bg_3 {
    background: #1c1c1c;
  }
}
</style>
